import { API } from '@/config/api.js'

export default {
  namespaced: true,
  state: () => ({
    inspectorInfo: null,
    landingInfo: null,
    loading: {
      inspector: false,
      landing: false
    },
    error: {
      inspector: null,
      landing: null
    }
  }),
  mutations: {
    SET_INSPECTOR_INFO(state, data) {
      state.inspectorInfo = data;
    },
    SET_LANDING_INFO(state, data) {
      state.landingInfo = data;
    },
    SET_LOADING(state, { key, value }) {
      state.loading[key] = value;
    },
    SET_ERROR(state, { key, value }) {
      state.error[key] = value;
    }
  },
  actions: {
    async fetchData({ commit }, { endpoint, payload, mutation, key }) {
      commit('SET_LOADING', { key, value: true });
      commit('SET_ERROR', { key, value: null });

      try {
        const response = await fetch(`${API.fullUrl}/${endpoint}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Server error: ${response.status} - ${errorText}`);
        }

        const data = await response.json();
        commit(mutation, data);
        return data;

      } catch (error) {
        console.error(`Error fetching ${endpoint}:`, error);
        commit('SET_ERROR', { key, value: error.message });
        return null;
      } finally {
        commit('SET_LOADING', { key, value: false });
      }
    },

    GET_INSPECTOR_INFO({ dispatch }, element) {
      return dispatch('fetchData', {
        endpoint: 'landing/block-inspector',
        payload: { element },
        mutation: 'SET_INSPECTOR_INFO',
        key: 'inspector'
      });
    },

    GET_LANDING_INFO({ dispatch }, landing) {
      return dispatch('fetchData', {
        endpoint: 'landing/landing-inspector',
        payload: { landing },
        mutation: 'SET_LANDING_INFO',
        key: 'landing'
      });
    }
  },
  getters: {
    inspectorInfo: (state) => state.inspectorInfo,
    landingInfo: (state) => state.landingInfo,
    inspectorLoading: (state) => state.loading.inspector,
    landingLoading: (state) => state.loading.landing,
    inspectorError: (state) => state.error.inspector,
    landingError: (state) => state.error.landing
  }
};
